import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { AppLoadingIndicatorService } from "../../../../../../services/app-loading-indicator.service";
import { take } from "rxjs";

/**
 * Un-finalizes a Valuation Event
 */
export class UnFinalizePortfolioGridActionHandler extends GridActionHandlerBase {
  /**
   * AppLoadingIndicatorService
   */
  private appLoadingIndicator: AppLoadingIndicatorService;
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'unfinalizePortfolio');
    this.appLoadingIndicator = this.injector.get(AppLoadingIndicatorService);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const selectedItem = this.workspace.grid.selectedItem;
    if (selectedItem) {
      if (!selectedItem.isFinalized) {
        this.eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //Nothing
          }
        }, 'portfolioNotFinalized');
        return;
      }

      const oid = selectedItem.Oid;
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          this.appLoadingIndicator.show();

          const unfinalizeUrl = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/unfinalize-portfolio?oid=${oid}`);
          this.http.post(unfinalizeUrl, {}).pipe(take(1)).subscribe({
            next: (gpr: any) => {
              this.appLoadingIndicator.hide();
              if (gpr.success) {
                this.workspace.grid.applyFilter(null, selectedItem.Oid).then(() => {
                  //Nothing
                });
              }
            },
            error: (_error) => {
              this.appLoadingIndicator.hide();
            }
          });
        },
        cancel: () => {
          //do nothing: just to show Cancel button
        }
      }, 'unfinalizePortfolioConfirmDialog');
    }
    else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
    }
  }
}
